import Loader from '@components/LayoutComponents/Loader'
import MenuLeft from '@components/LayoutComponents/Menu/MenuLeft'
import MenuTop from '@components/LayoutComponents/Menu/MenuTop'
import { FloatButton, Layout } from 'antd'
import React, { useEffect, useState } from 'react'

import styles from './style.module.scss'

const MainLayout = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // TODO: remove after React v18 migration completed fully. Highly unrecommend to keep as is.
    const timeout = setTimeout(() => {
      setIsLoading(false)
    }, 100)

    return () => {
      clearTimeout(timeout)
    }
  }, [])

  return (
    <>
      <FloatButton.BackTop />
      {isLoading ? <Loader fullScreen /> : null}
      <Layout className="settings__menuTop">
        <MenuLeft />
        <Layout>
          <Layout.Header className={styles.stickyNav}>
            <MenuTop />
          </Layout.Header>
          <Layout.Content style={{ position: 'relative' }}>
            {children}
          </Layout.Content>
        </Layout>
      </Layout>
    </>
  )
}

export default MainLayout
